export const AustralianCities = [
    {
        cityName: '悉尼',
        cityEnglishName: 'Sydney',
        cityCode: 'SYD',
        theAirportName: '悉尼金斯福德机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
    {
        cityName: '墨尔本',
        cityEnglishName: 'Melbourne',
        cityCode: 'MEL',
        theAirportName: '墨尔本机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
    {
        cityName: '布里斯班',
        cityEnglishName: 'Brisbane',
        cityCode: 'BNE',
        theAirportName: '布里斯班机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
    {
        cityName: '黄金海岸',
        cityEnglishName: 'Gold Coast',
        cityCode: 'OOL',
        theAirportName: '黄金海岸机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
    {
        cityName: '凯恩斯',
        cityEnglishName: 'Cairns',
        cityCode: 'CNS',
        theAirportName: '凯恩斯机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
    {
        cityName: '阿德莱德',
        cityEnglishName: 'Adelaide',
        cityCode: 'ADL',
        theAirportName: '阿德莱德机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
    {
        cityName: '珀斯',
        cityEnglishName: 'Perth',
        cityCode: 'PER',
        theAirportName: '珀斯机场',
        countryName: '澳大利亚',
        countryCode: 'AU',
    },
];
